import { createGlobalStyle } from "styled-components"
export const GlobalStyle = createGlobalStyle`
@import url('https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,500;0,700;1,400&display=swap');
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        overflow-x:hidden;
        font-family: 'Ubuntu', sans-serif;
        }`


